<template>
  <v-container fluid class="carousel">
    <v-container>
        <h2 class="text-center my-4">Fruitisimo BISTRO CAFÉ v Galerii Harfa</h2>
        <vue-carousel :perPage="slidesPerPage" paginationActiveColor="#F58220">
            <slide v-for="(item,index) in slides" :key="index">
                <v-img :src="item" aspect-ratio="2" contain></v-img>
            </slide>
        </vue-carousel>
    </v-container>
  </v-container>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'Carousel',
        components: {
            'VueCarousel': Carousel,
            Slide
        },
        data: () => ({
           slides: [
               require('../assets/carousel/2ACDC02F-E8B0-4698-95D7-61680499FEED_1_201_a-min.jpeg'),
               require('../assets/carousel/8F1FD59A-EAF6-4CCA-8D19-B8A303156022_1_201_a-min.jpeg'),
               require('../assets/carousel/49E3FBC8-E2B1-4B18-8986-1078E9AD47A0_1_201_a-min.jpeg'),
               require('../assets/carousel/85303D81-6BD2-4BC4-AC77-48E7DA8A25BB_1_201_a-min.jpeg'),
               require('../assets/carousel/371DF49C-B214-48AD-886A-0AD8BEA02135_1_201_a-min.jpeg'),
               require('../assets/carousel/D89E843C-A044-4859-86BD-A388A05DCC3F_1_201_a-min.jpeg'),
               require('../assets/carousel/E727805E-123F-4097-B352-E146F118D74B_1_201_a-min.jpeg')
           ]
        }),
        computed: {
          slidesPerPage() {
              switch (this.$vuetify.breakpoint.name) {
                  case 'xs': return 1
                  case 'sm': return 2
                  case 'md': return 3
                  case 'lg': return 3
                  case 'xl': return 3
              }
              return 5;
          }
        },
    }
</script>

<style lang="scss">
  .carousel {
      .VueCarousel-dot {
          outline: none!important;
      }
      h2 {
          font-size: 26px;
      }
  }
</style>